import script from "./TipsPop.vue?vue&type=script&lang=ts&setup=true"
export * from "./TipsPop.vue?vue&type=script&lang=ts&setup=true"

import "./TipsPop.vue?vue&type=style&index=0&id=12d69a0f&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12d69a0f"]])

export default __exports__